import React from 'react';
import classes from "./Lineups2.module.css";
import TeamLineups2 from './TeamLineups2';

const Lineups2 = ({ homeTeam, awayTeam }) => {
    return (
        <div className={classes.line_up_container}>

            {/* Home team info bar */}
            <div className={classes.home_team_info}>
                <div className={classes.home_team_info_sub}>
                    <img src={homeTeam?.team?.logo} className={classes.home_team_logo} alt={homeTeam?.team?.name} />
                    <p className={classes.home_team_name}>{homeTeam?.team?.name}</p>
                </div>
                <p className={classes.home_team_formation}>{homeTeam?.formation}</p>
            </div>

            {/* Pitch */}
            <div className={classes.line_up_sub_container}>
                <img src="/assets/images/football-ground.jpg" alt="football ground" className={classes.ground} />
                <div className={classes.home_team}>
                    <TeamLineups2
                        homeTeam={true}
                        team={homeTeam?.team}
                        coach={homeTeam?.coach}
                        startXI={homeTeam?.startXI}
                        formation={homeTeam?.formation}
                    />
                </div>
                <div className={classes.away_team}>
                    <TeamLineups2
                        homeTeam={false}
                        team={awayTeam?.team}
                        coach={awayTeam?.coach}
                        startXI={awayTeam?.startXI}
                        formation={awayTeam?.formation}
                    />
                </div>
            </div>

            {/* Away team info bar */}
            <div className={classes.home_team_info}>
                <div className={classes.home_team_info_sub}>
                    <img src={awayTeam?.team?.logo} className={classes.home_team_logo} alt={awayTeam?.team?.name} />
                    <p className={classes.home_team_name}>{awayTeam?.team?.name}</p>
                </div>
                <p className={classes.home_team_formation}>{awayTeam?.formation}</p>
            </div>
        </div>
    );
};

export default Lineups2;